import type { ComponentChildren } from "preact";
import { useState } from "preact/hooks";

import type { AuthenticationProvider, MetaFeatures } from "../RESTTypes";

import { Footer } from "./Footer";
import { LoginProviders } from "./LoginProviders";
import { ModalWrapper } from "./ModalWrapper";
import { SSO } from "./SSO";

export function LoginModal({
  metaFeatures,
  onLogin,
  getSSORedirectUrl,
}: {
  metaFeatures: MetaFeatures;
  onLogin: (provider: AuthenticationProvider) => void;
  getSSORedirectUrl: (email: string) => Promise<string>;
}) {
  const [page, setPage] = useState<"login" | "sso">("login");

  const isOnlyWorkos =
    !metaFeatures.loginWithGithub &&
    !metaFeatures.loginWithGoogle &&
    !metaFeatures.loginWithApple &&
    metaFeatures.loginWithWorkos;

  let footer: ComponentChildren = null;

  if (metaFeatures.loginWithWorkos && !isOnlyWorkos) {
    footer = (
      <Footer>
        {page === "login" ? (
          <button
            class="csb-api-bIjkRi csb-api-ljdegr"
            onClick={() => setPage("sso")}
            type="button"
          >
            Sign in with SSO
          </button>
        ) : (
          <span class="csb-api-gDXMLZ csb-api-hyGEHp">
            Not SSO?
            <button
              class="csb-api-bIjkRi csb-api-ljdegr"
              onClick={() => setPage("login")}
              type="button"
            >
              Sign in
            </button>
          </span>
        )}
      </Footer>
    );
  } else {
    footer = <Footer />;
  }

  if (isOnlyWorkos) {
    return (
      <ModalWrapper>
        <SSO
          changeSignInMode={() => setPage("login")}
          getSSORedirectUrl={getSSORedirectUrl}
          onValidInitialize={(ssoUrl) => {
            onLogin({
              type: "sso",
              redirectUrl: ssoUrl,
            });
          }}
        />
        {footer}
      </ModalWrapper>
    );
  }

  return (
    <ModalWrapper>
      <div class="csb-api-gDXMLZ csb-api-icIAxa">
        {page === "login" ? (
          <LoginProviders onLogin={onLogin} />
        ) : (
          <SSO
            changeSignInMode={() => setPage("login")}
            getSSORedirectUrl={getSSORedirectUrl}
            onValidInitialize={(ssoUrl) => {
              onLogin({
                type: "sso",
                redirectUrl: ssoUrl,
              });
            }}
          />
        )}
      </div>
      {footer}
    </ModalWrapper>
  );
}
